import { PDFSections } from '@/types';

export const RESULT_PDF_SECTIONS: PDFSections[] = [
	PDFSections.REBA,
	PDFSections.NIOSH,
	PDFSections.KIM_PP,
	PDFSections.KIM_MHO,
	PDFSections.KIM_MHO,
	PDFSections.STRAIN_INDEX,
	PDFSections.ACTION_PLANS,
	PDFSections.NOT_EVALUATED,
	PDFSections.WORK_CONDITIONS,
	PDFSections.CHARACTERISTICS
];
